import React from "react";
import {
  deleteRelationShipId,
  getallPermissionsRelationShips,
} from "../../redux/features/permissionSlice";
import { useSelector } from "react-redux";
import GlobalDeleteDialog from "../../components/mui/Dialogue/GlobalDeleteDialog";
const DeleteRelationShip = ({ relationId, permissionID }) => {
  const { loading } = useSelector((store) => store.permission);
  return (
    <GlobalDeleteDialog
      disabled={false}
      title={"Delete"}
      deleteNote={
        "Are you sure? you want to delete this Permission Relation..?"
      }
      api={deleteRelationShipId(relationId)}
      upDateCall={getallPermissionsRelationShips(permissionID)}
      //   updatePaginationCall={savePaginationData({ ...paginationData, openAnchor: false })}
      loading={loading}
    />
  );
};
export default DeleteRelationShip;
